import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 425;
const TABLET_MIN = 768;
const TABLET_MAX = 1024;
const LAPTOP_MIN = 1025;

export function useScreenSize(): {
  isSmallMobile: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
} {
  const [isSmallMobile, setIsSmallMobile] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const isClient = typeof window === "object";
    if (!isClient) {
      return;
    }

    function handleResize() {
      if (isClient) {
        setIsSmallMobile(window.innerWidth <= MOBILE_BREAKPOINT);
        setIsMobile(window.innerWidth < TABLET_MIN);
        setIsTablet(
          window.innerWidth >= TABLET_MIN && window.innerWidth <= TABLET_MAX
        );
        setIsDesktop(window.innerWidth >= LAPTOP_MIN);
      } else {
        setIsSmallMobile(false);
        setIsMobile(false);
        setIsTablet(false);
        setIsDesktop(false);
      }
    }

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return {
    isSmallMobile,
    isMobile,
    isTablet,
    isDesktop,
  };
}
